<template>
  <div class="batch-upload-img">
        <div v-if="isLoading" class="batch-loading">
            <lottie-player src="../../../static/js/lf30_editor_TllSye.json"  background="transparent"  speed="1" color="#000"  style="width: 80px; height: 80px;"  loop autoplay></lottie-player>
        </div>
       <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <modal class="select-cover" :display="modal" @modalStatus="closeModal()" >
            <h1>選擇封面</h1>
            <div class="content">
                <img-checkbox :selectId="selects[houseIndex]" :imageFile="files[houseIndex]" @getSelectId="val => selectTemp = val"></img-checkbox>
            </div>
            <div class="btn-group">
                <button class="default-button" @click="closeModal(),selects[houseIndex] = selectTemp">確認</button>
                <button class="border-button" @click="closeModal()">取消</button>
            </div>
        </modal>
        <div  v-if="files[houseIndex].length" class="has-img">
            <ul>
                <li v-for="(file, index) in files[houseIndex]" :key="index">
                    <div v-if="files[houseIndex].length > 1 && selects[houseIndex] == index" class="cover-setting" @click="modal = true">
                        封面
                        <img src="@/assets/img/icon/edit_green.svg" alt="">
                    </div>
                    <div class="preview">
                        <img  :src="file.blob" />
                    </div>
                    <img class="cancel" @click.prevent="deletImg(index), $refs['upload'+houseIndex].remove(file)" src="@/assets/img/icon/cancel_black.svg" alt="">
                    <span v-if="file.error">{{file.error}}</span>
                </li>
                <li class="list-upload" v-show="files[houseIndex].length < 10">
                    <file-upload
                    class="upload-btn"
                    post-action="/upload/post"
                    :input-id="'file'+houseIndex"
                    :size="1024 * 5"
                    :maximum="10"
                    :multiple="true"
                    :drop="true"
                    :drop-directory="true"
                    v-model="files[houseIndex]"
                    @input-file="inputFile"
                    @input-filter="inputFilter"
                    :ref="'upload'+houseIndex">
                    <img class="upload-icon" src="@/assets/img/icon/upload.svg" alt="">
                    上傳圖片
                    </file-upload>
                </li>
            </ul>
        </div>
        <div v-else class="no-img" :class="{'drop-active': $refs['upload'+houseIndex] && $refs['upload'+houseIndex].dropActive}">
            <!-- <button class="upload-btn">上傳圖片</button> -->
            <file-upload
            class="upload-btn"
            post-action="/upload/post"
            :input-id="'file'+houseIndex"
            :size="1024 * 5"
            :maximum="10"
            :multiple="true"
            :drop="true"
            :drop-directory="true"
            v-model="files[houseIndex]"
            @input-file="inputFile"
            @input-filter="inputFilter"
            :ref="'upload'+houseIndex">
                <div class="upload-alarm">僅接受 jpg、png，每張不得超過 5 MB，上限為 10 張圖片，建議尺寸 300 x 400 px</div>
                <span class="upload-description"><img class="upload-icon" src="@/assets/img/icon/upload.svg" alt="">拖放檔案或點擊此區立即上傳</span>
            </file-upload>
            <span class="upload-drop-alarm">將圖片拖放到這裡</span>
        </div> 
  </div>
</template>
<script>
import FileUpload from 'vue-upload-component';
import Modal from '@/components/widge/Modal.vue';
import ImgCheckbox from '@/components/widge/ImgCheckbox.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            files: [],
            selects: [],
            selectTemp: null,
            modal: false,
            isLoading: false,
            isFirstUpload: true,
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
        }
    },
    props:{
        houseIndex: ''
    },
    mounted () {
        let hid = this.houseIndex
        this.files = {
            [hid]: []
        }
        this.selects = {
            [hid]: 0
        }
    },
    watch: {
        files: {
            handler: function (val) {
                this.uploadImg(val)
                // 塞入有更改的index
                
            },
            deep: true
        },
        selects:{
            handler:function (val) {
                // console.log('封面index:'+val[this.houseIndex])
                this.$store.dispatch('saveBatchCoverImage', {houseIndex: this.houseIndex, index: val[this.houseIndex]})
                this.$store.dispatch('setBatchCover', this.selects)
            },
            deep: true
        },
    },
    methods: {
        uploadImg: function (val) {
            if(val[this.houseIndex].length){
                this.isLoading = true
                this.$store.dispatch('setModifyBatchImagesIndex', parseInt(Object.keys(val)))
                this.$store.dispatch('setBatchImageFiles', this.files)
                .then( (res) => {
                    console.log(res)
                    this.isLoading = false
                    if(this.isFirstUpload){
                        this.isFirstUpload = false
                        this.$store.dispatch('saveBatchCoverImage', {houseIndex: this.houseIndex, index: 0})
                    }
                })

            }
        },
        deletImg: function (index) {
            this.$store.dispatch('delBatchImage', {houseIndex: this.houseIndex, index: index})
            .then(() => {
                this.isLoading = false
                if(index < this.selects[this.houseIndex]){
                    this.selects[this.houseIndex] = this.selects[this.houseIndex] - 1
                }else if(index == this.selects[this.houseIndex] && index != 0){
                    this.selects[this.houseIndex] = this.selects[this.houseIndex] - 1
                    this.$store.dispatch('saveBatchCoverImage', {houseIndex: this.houseIndex, index: this.selects[this.houseIndex]})
                }else{
                    this.$store.dispatch('saveBatchCoverImage', {houseIndex: this.houseIndex, index: this.selects[this.houseIndex]})
                }
            })
            .catch(err => {
                this.alart.fail = true
                this.msg.error = '刪除圖片失敗'
            })
        },
        closeModal: function (type) {
            this.modal = false
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                // console.log('response', newFile.response)
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                // if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
                // return prevent()
                // }
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.msg.error = '請上傳JPG或PNG檔案'
                    return prevent()
                }
                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.msg.error = '檔案最大限制5MB'
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.hid = this.houseIndex
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
    },
    computed: {
        ...mapGetters({
            imageUploadLoading: 'GET_BATCH_IMAGE_UPLOAD_LOADING',
        })
    },
    components: {
        FileUpload,
        Modal,
        ImgCheckbox,
        AlartMsg
    },
}
</script>
<style lang="scss" scoped>
    .batch-upload-img{
        // position: relative;
        .batch-loading{
            position: absolute;
            z-index: 999;
            background-color: rgba(255, 255, 255, 0.5);
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            top: 0px;
            left: 0px;
        }
        .file-uploads{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }
        .no-img{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 97px;
            border-radius: 2px;
            border: dashed 1px #cacfcd;
            background-color: #ffffff;
            margin-top: 20px;
            .upload-alarm{
                color: #a8a5a4;
                margin-bottom: 14px;
            }
            .upload-description{
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .upload-btn{
                .upload-icon{
                    width: 18px;
                    height: 18px;
                    margin-right: 8px;
                }
            }
            .upload-drop-alarm{
                display: none;
            }
        }
        .no-img.drop-active{
            border: solid 1px #ff9275;
            background-color: rgba(255, 146, 117, 0.1);
            .upload-btn,
            .upload-description{
                display: none;
            }
            .upload-drop-alarm{
                display: block;
                font-weight: 500;
                color: #ff9275;
            }
            
        }
        .has-img{
            ul{
                display: flex;
                flex-wrap: wrap;
                li{
                    position: relative;
                    margin-right: 16px;
                    margin-top: 20px;
                    .preview{
                        width: 124px;
                        height: 93px;
                        display: flex;
                        align-items: center;
                        border-radius: 4px;
                        overflow: hidden;
                        >img{
                            width: 100%;
                        }
                    }
                    .cancel{
                        position: absolute;
                        cursor: pointer;
                        top: -14px;
                        right: -14px;
                    }
                    .cover-setting{
                        position: absolute;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 96px;
                        height: 44px;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        background-color: #ffffff;
                        border-radius: 4px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        >img{
                            margin-left: 8px;
                        }
                    }
                }
                li:nth-child(8n){
                    margin-right: 0px;
                }
                .list-upload{
                    width: 124px;
                    height: 93px;
                    border-radius: 4px;
                    border: dashed 1px #cacfcd;
                    background-color: #ffffff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 18px;
                        margin-bottom: 8px;
                    }
                    .file-uploads{
                        flex-direction: column;
                    }
                }
            }
        }
        .select-cover{
            .modal-content{
                width: 1004px;
                padding: 0 !important;
                h1{
                    margin-top: 32px;
                    margin-bottom: 40px;
                }
                .content{
                    padding: 0 32px 10px 32px;
                    height: 400px;
                    overflow-x: hidden;
                }
                .content::-webkit-scrollbar {
                    display: none;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/landlord/houseStatus/houseManagement/batchHouse/uploadBatchImg.vue